import AircraftModel from "../aircraft/AircraftModel";
import Attack from "./Attacks";

class ImpersonationAttack extends Attack {
    /**
     * Creates an instance of ImpersonationAttack.
     * 
     * @param {number} startTimestamp
     * @param {AircraftModel} aircraftToImpersonate
     */
    constructor(startTimestamp, aircraftToImpersonate) {
        super(startTimestamp);

        /**
         * The callsign of the aircraft to impersonate
         * 
         * @property callsignToImpersonate
         * @type {string}
         * @default ''
         */
        this.fakeCallsign = aircraftToImpersonate.callsign;

        /**
         * Fake transponder code of the aircraft
         * 
         * @property fakeTransponderCode
         * @type {string}
         * @default ''
         */
        this.fakeTransponderCode = aircraftToImpersonate.transponderCode;

        this.init();
    }

    /**
     * Initialize the attack
     * 
     * @for ImpersonationAttack
     * @method init
     */
    init() {
        super.init();
    }

    update() {
        // update the attack data
    }

    end(endTimestamp) {
        super.end(endTimestamp);
    }
}

export default ImpersonationAttack;